import apiClient from "./client";

export const userSignUp = async (userData) => {
  const response = await apiClient.post("/user/signup", userData);
  return response.data;
};

export const getBanners = async () => {
  const response = await apiClient.get("/banners");
  return response.data;
};

export const getSystemValues = async () => {
  const response = await apiClient.get("/system-values");
  return response.data;
};
